(function($) {
  "use strict";

  jQuery(document).ready(function(){
  	$('#shopify-section-16518241314cd46cce').addClass('h-sec-1');
  	$('#shopify-section-16512341300938fb42').addClass('home-featureds');
    
  	$('#shopify-section-16518331569ae368bd').addClass('h-sec-2');
  	$('#shopify-section-1651836113bda54304').addClass('h-sec-3');
  	$('#shopify-section-1651851767ea25884e').addClass('h-sec-4');
  	$('#shopify-section-16518465669b01eab8').addClass('h-sec-5');
  	$('#shopify-section-1562136321683').addClass('h-sec-6');
  	$('#shopify-section-1556613976053').addClass('h-sec-7');
  	$('#shopify-section-1556530642117').addClass('h-sec-8');
    
    
  	$('.home-featureds').appendTo('.h-sec-1');
  	$('.home-featureds .ht-products').addClass('owl-carousel');
    
    setTimeout(function() { 
    	$(".ets_cf_submit_left button").removeClass().addClass('green-button');
    }, 1000);
    
    $(window).on('load', function () {
      setTimeout(function() {
    	$(".cd-cart-footer button").removeClass().addClass('gr-simple-button');
      }, 1000);
    });
    
    $('.slider-images').owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 2000,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      item: 1,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });
    $('.home-featureds .ht-products').owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 5000,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      item: 3,
      responsive: {
        0: {
          items: 3
        },
        768: {
          items: 3
        },
        1000: {
          items: 3
        }
      }
    });
    $('.h-sec-4 .offer-inner .owl-carousel').owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 5000,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      item: 3,
      responsive: {
        0: {
          items: 3
        },
        768: {
          items: 3
        },
        1000: {
          items: 3
        }
      }
    });
    $('.about-story-center .owl-carousel').owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 5000,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      item: 3,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        },
        1000: {
          items: 3
        }
      }
    });
    
    $('.footer-social').clone().appendTo('.head-social');
    
    $(document).on("click",".sticky-btn",function() {
        $('.sticky-contact').toggleClass('active');
    });
    
     $(function () {
       $('.qty input').change(function() {
         if ($(this).val() > 0) {
           $(this).parents('li').addClass('selected');
         }
         else{
           $(this).parents('li').removeClass('selected');
         }
         
        });
    });
    
    
    $(document).on("click","#wholesale input[name='Name']",function() {
        $('textarea[name="ProductsWithQTY"]').val('');
      	$('.pro-selecteds').html('');
        
        $('.product-li.selected input').each(function( index ) {
          var qty = $(this).val();
          var link = $(this).attr('data-link');
          $('.pro-selecteds').append('<br>'+link+' = QTY: '+qty+'&#13;&#10');
          var ProductSelected = $('.pro-selecteds').html();
          //alert(link);
          $('textarea[name="ProductsWithQTY"]').val(ProductSelected);
        });
    });
    
    
    
    
  });
})(jQuery);